import { ADD_REMINDER } from '@app/actions/reminders';

const initialState = {
  all: {},
};

const currentTime = (state = initialState, action) => {
  switch (action.type) {
    case ADD_REMINDER:
      return {
        ...state,
        all: {
          ...state.all,
          [action.id]: {
            setRemindDate: action.setRemindDate,
            toRemindDate: action.toRemindDate,
            message: action.message,
            linkTo: action.linkTo,
          },
        },
      };
    default:
      return state;
  }
};

export default currentTime;



// WEBPACK FOOTER //
// ./src/reducer/reminders.js